import { observer } from 'mobx-react-lite'
import {
  type InfiniteScroller,
  useInfiniteScroll,
} from '@/hooks/infinite-scroll-hooks'
import { InfiniteScrollLoader } from '@/components/InfiniteScrollLoader'

interface InfiniteScrollLoaderContainerProps {
  scrollProvider: InfiniteScroller
  compact?: boolean
}

/**
 * Connects an {@link InfiniteScrollLoader} to the scroller whose next page it loads.
 */
export const InfiniteScrollLoaderContainer = observer(
  function InfiniteScrollLoaderContainer({
    scrollProvider,
    compact,
  }: InfiniteScrollLoaderContainerProps) {
    const { connectRef } = useInfiniteScroll({ scroller: scrollProvider })

    return (
      <InfiniteScrollLoader
        ref={connectRef}
        isDone={scrollProvider.isDone}
        compact={compact}
      />
    )
  },
)
